document.addEventListener('DOMContentLoaded', function () {
  var accordionTitles = document.querySelectorAll('.am-accordion__title');

  accordionTitles.forEach(function (title) {
    title.addEventListener('click', function (event) {
      var closestCard = this.closest('.am-accordion__card');
      var dropDown = closestCard.querySelector('.am-accordion__panel');
      var accordion = closestCard.closest('.am-accordion');
      var activeTitles = accordion.querySelectorAll('.am-accordion__title.active');

      accordion.querySelectorAll('.am-accordion__panel').forEach(function (panel) {
        if (panel !== dropDown) {
          panel.style.display = 'none';
        }
      });

      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        activeTitles.forEach(function (activeTitle) {
          activeTitle.classList.remove('active');
        });
        this.classList.add('active');
      }

      if (window.getComputedStyle(dropDown).display === 'none') {
        dropDown.style.display = 'block';
      } else {
        dropDown.style.display = 'none';
      }

      event.preventDefault();
    });
  });

   document.getElementById("art-of-application").addEventListener("click", function() {
  const target = document.getElementById("attar-application");

  const desktopOffset = 150; 
  const mobileOffset = 100; 

  const headerOffset = window.innerWidth > 768 ? desktopOffset : mobileOffset;

  const elementPosition = target.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
});
});
